import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
import { useModel } from '@umijs/max';

const Footer: React.FC = () => {
  const { company } = useModel('config');

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`2026 ${company} 版权所有`}
    />
  );
};

export default Footer;
